import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../../shared/services/user.service';

@Component({
  template: ` <p>Logout in progress...</p> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class LogoutComponent {
  private userService = inject(UserService);

  constructor() {
    this.userService.logoutWithoutRedirect();
  }
}
